import { MiWalletService } from "../../services/miWallet/miWallet";


export const MIWalletTiles = async () => {
    try {
        const response = await MiWalletService.callTiles();
        return response
    } catch (error) {
        return error.message
    }
}

export const MIWalletStatement = async (page, itemsPerPage, sortBy, direction) => {
    try {
        const response = await MiWalletService.callStatement(page, itemsPerPage, sortBy, direction);
        return response
    } catch (error) {
        return error.message
    }
}



export const MIWalletMyEarnings = async (page, itemsPerPage, selectedCategory, startDate, endDate, sortBy, direction) => {
    try {
        const response = await MiWalletService.callMyEarnings(page, itemsPerPage, selectedCategory, startDate, endDate, sortBy, direction);
        return response
    } catch (error) {
        return error.message
    }
}



// export const EwalletBalance = async () => {
//     try {
//         const response = await MiWalletService.callEwalletBalance();
//         return response
//     } catch (error) {
//         console.log(error.message);
//     }
// }